import React from 'react';
import Logo from './components/Logo';
// import JoulepointLogo from './assets/companyLogo/jplogo.png';
import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import store, { login, setAuthStateAsIntiital } from './store';
import checkAuth from './utils/auth/checkAuth';
import AdminLayout from './layouts/Admin';
import CorporateAdminLayout from './layouts/CorporateAdmin';
import AuthLayout from './layouts/Auth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryParamProvider } from 'use-query-params';
import 'leaflet/dist/leaflet.css';

const queryClient = new QueryClient();

function App() {
  const isLoggedIn = store.useState((s) => s.auth.isLoggedIn);
  const isCheckingAuth = store.useState(
    (s) => s.authHelperStates.isCheckingAuth,
  );

  const isLoggingOut = store.useState((s) => s.authHelperStates.isLoggingOut);

  useEffect(() => {
    const setIsCheckingAuth = (val) =>
      store.update((s) => {
        s.authHelperStates.isCheckingAuth = !!val;
      });

    setIsCheckingAuth(true);
    checkAuth()
      .then(login)
      .catch(setAuthStateAsIntiital)
      .finally(() => setIsCheckingAuth(false));
  }, []);

  if (isCheckingAuth || isLoggingOut) {
    return (
      <div className="vh-100">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <Logo className="animate__animated animate__tada animate__slow animate__infinite" />
        </div>
      </div>
    );
  }

  const defaultPage = '/admin';

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            <Route path="/auth/login" exact>
              {isLoggedIn ? <Redirect to={defaultPage} /> : <AuthLayout />}
            </Route>
            <Route path="/auth/signup" exact>
              {isLoggedIn ? <Redirect to={defaultPage} /> : <AuthLayout />}
            </Route>
            <Route path="/auth/forgotPassword" exact>
              {isLoggedIn ? <Redirect to={defaultPage} /> : <AuthLayout />}
            </Route>
            <Route path="/admin">
              {isLoggedIn ? <AdminLayout /> : <Redirect to="/auth/login" />}
            </Route>
            <Route path="/corporate">
              {isLoggedIn ? (
                <CorporateAdminLayout />
              ) : (
                <Redirect to="/auth/login" />
              )}
            </Route>
            <Route path="/" exact>
              {isLoggedIn ? (
                <Redirect to={defaultPage} />
              ) : (
                <Redirect to="/auth/login" />
              )}
            </Route>
          </Switch>
        </QueryParamProvider>
      </Router>
      {/* <Footer>
        <p className="text-muted text-center">
          &copy; {new Date().getFullYear()} JoulePoint Private Limited
        </p>
      </Footer> */}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

function AppWithDevFeatures(props) {
  const [isStateShown, setIsStateShown] = useState(false);
  const state = store.useState((s) => s);

  return (
    <>
      <App {...props} />

      <div
        className="p-1 position-fixed"
        style={{ bottom: 0, left: 0, opacity: 0.9 }}
      >
        {isStateShown && (
          <pre className="bg-secondary rounded text-light p-1 animate__animated animate__bounceIn animate__faster">
            {JSON.stringify(state, null, 2)}
          </pre>
        )}
        <button
          className="btn btn-secondary border"
          onClick={() => setIsStateShown((v) => !v)}
          style={{ fontFamily: 'monospace' }}
        >
          Global state [{isStateShown ? '-' : '+'}]
        </button>
      </div>
    </>
  );
}

export default (() => {
  if (process.env.NODE_ENV === 'production') {
    return App;
  }

  return AppWithDevFeatures;
})();
